import React from 'react';
import { FormTemplateQuestionFieldsKindEnum } from 'graphql-common';
import RadioButtonGroup from '@lib/components/RadioButtonGroup/RadioButtonGroup';
import { ComponentProps, defaultProps } from '../types';

export default function RadioButtonPreview({ options }: ComponentProps) {
  const preparedOptions = options.map(({ values }) => ({
    value: values[0],
    label: values[0],
  }));
  return (
    <RadioButtonGroup
      options={preparedOptions}
      value={undefined}
      name={FormTemplateQuestionFieldsKindEnum.RadioButton}
      {...defaultProps}
    />
  );
}
